import script from "./sipView.vue?vue&type=script&setup=true&lang=js"
export * from "./sipView.vue?vue&type=script&setup=true&lang=js"

import "./sipView.vue?vue&type=style&index=0&id=7903c4c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7903c4c3"]])

export default __exports__